
function addCommas(x) {
	var number = removeCommas(x)
	return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

function removeCommas(x) {
	return x ? parseFloat(x.toString().replace(/[,$]/g, '')) : 0
}

function setupGltrCalculator(calculator) {

	const calculatorSalary = calculator.querySelector('#base-salary')

	const impactRating = calculator.querySelectorAll('.impact-rating__cont .impact-rating__option')
	const calculatorPercentage = calculator.querySelector('.calculator-percentage')
	const calculatorResults = calculator.querySelector('.calculator-results')
	const targetOptions = calculator.querySelectorAll('.calculator__target-options .calculator__radio-button')
	const criticalSkills = calculator.querySelectorAll('.critical-skills__option')

	function update() {
		// Fetch values
		var salary = removeCommas(calculatorSalary.value) * 1
		var target = calculator.querySelector('input[name="target-award"]:checked').value * 1
		var impact = calculator.querySelector('input[name="talent-rating"]:checked').value * 1
		var skills = calculator.querySelector('input[name="critical-skills"]:checked').value * 1

		// Overwrite values for F Band + Talent only
		if (target === 20 && impact === 0 && skills === 0) {
			skills = 0
			target = 0
		} else if (target === 20 && impact === 0 && skills === 10) {
			skills = 0
			target = 20
		}

		// Calculate final values
		var percentage = (impact + skills) * (target / 100) + target
		var value = salary * (percentage / 100)

		// Print final values
		if (percentage != 0) {
			calculatorPercentage.innerHTML = `${percentage}%`
		} else {
			calculatorPercentage.innerHTML = 'No Award'
		}
		
		calculatorResults.innerHTML = addCommas(Math.round(value))

	}

	calculator.addEventListener('keyup', update)
	calculator.addEventListener('change', update)
	calculator.addEventListener('input', update)


	// Set active states on fields
	function addActiveState(element) {
		element.forEach(el =>  {
			el.addEventListener('click', () => {
				element.forEach(el =>  {
					el.classList.remove('active')
				})
				el.classList.add('active')
			})
		})
	} 

	addActiveState(impactRating)
	addActiveState(targetOptions)
	addActiveState(criticalSkills)
}


[...document.querySelectorAll('.gltr-calculator')].map(setupGltrCalculator)